import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from "react";

export interface SidebarContextType {
  collapsed?: boolean;
  setCollapsed?: (collapsed: boolean) => void;
  doNotTrack?: boolean;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<
  SidebarContextType & { children: ReactNode }
> = (props) => {
  const { children, collapsed: initialCollapsed, ...rest } = props;
  const [collapsed, setCollapsed] = useState(initialCollapsed ?? false);

  useEffect(() => {
    if (initialCollapsed !== undefined) {
      setCollapsed(initialCollapsed);
    }
  }, [initialCollapsed]);

  return (
    <SidebarContext.Provider value={{ ...rest, collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
